import { create } from 'zustand';

type CreatorCroppedAvatar = {
  [creatorId: string]: Blob;
};

type Store = {
  creatorCroppedAvatar?: CreatorCroppedAvatar;
  setCroppedImage: (creatorId: string, blob: Blob) => void;
  getCropperImage: (creatorId: string) => string | undefined;
};

export const useCreatorStore = create<Store>()((set, get) => ({
  setCroppedImage: (creatorId, blob) =>
    set((state) => {
      const updatedCreatorCroppedAvatar = {
        ...state.creatorCroppedAvatar,
        [creatorId]: blob,
      };
      return { creatorCroppedAvatar: updatedCreatorCroppedAvatar };
    }),
  getCropperImage: (creatorId) => {
    const avatar = get().creatorCroppedAvatar?.[creatorId];
    return avatar && URL.createObjectURL(avatar);
  },
}));
